export const BANK = {
  name: "Brightside Befriending Services Ltd",
  account: "69019532",
  sort: "60-84-64",
  bank: "Wise Payments Limited, Worship Square, 65 Clifton Street, London, EC2A 4JE, United Kingdom",
};
